<template lang="pug">
div.subject-form
  el-row
    el-col(:sm="4")
      el-tag(:closable="true", @close="onClose", type="gray") {{ consts.subjectType[payment.type][subject.type].title }}


    //- el-col(:sm="10")
      el-form-item(:prop="'Subjects.' + index + '.EventId'", :rules="{required: true, type: 'number', message: 'Задължително'}")
        el-select(v-model="subject.EventId", placeholder="Научно събитие/Година", :remote-method="eventAhead", filterable, remote, :loading="eventLoading", @change="eventChange")
          el-option(v-for="e in eventOptions", :label="e.text", :value="e.id", :key="e.id")

    //- el-col(:sm="2") Кол
    //- el-col(:sm="3") Цена
    //- el-col(:sm="2") Отстъпка
    //- el-col(:sm="3") Сума
  el-row
    //- 1010
    el-col(:sm="2", v-if="subject.type == 1010")
      el-form-item(:prop="'Subjects.' + index + '.year'", :rules="{required: true, type: 'number', message: 'Задължително'}")
        el-select(v-model="subject.year", placeholder="Година")
          el-option(v-for="y in subjectYears(subject)", :label="y", :value="y", :key="y")
    el-col(:sm="4", v-if="subject.type == 1010")
      el-form-item(:prop="'Subjects.' + index + '.subscriptionType'", :rules="{required: true, type: 'number', message: 'Задължително'}")
        el-select(v-model="subject.subscriptionType", placeholder="Тип", @change="subscriptionTypeChange")
          el-option(v-for="(st, id) in consts.subscriptionType", :label="st.title", :value="parseInt(id)", :key="id")
    el-col(:sm="4", v-if="subject.type == 1010")
      el-form-item(:prop="'Subjects.' + index + '.subscriptionVariant'", :rules="{required: true, type: 'number', message: 'Задължително'}")
        el-select(v-model="subject.subscriptionVariant", placeholder="Вариант", @change="subscriptionVariantChange")
          el-option(v-for="(sv, id) in consts.subscriptionVariant", :label="sv.title", :value="parseInt(id)", :key="id", :disabled="sv.disabled")
    el-col(:sm="4", v-if="subject.type == 1010")
      el-form-item(:prop="'Subjects.' + index + '.delivery'", :rules="{required: true, type: 'number', message: 'Задължително'}")
        el-select(v-model="subject.delivery", placeholder="Начин на получаване")
          el-option(v-for="(d, id) in consts.subjectDelivery", :label="d", :value="parseInt(id)", :key="id")
    //- 1020
    el-col(:sm="2", v-if="subject.type == 1020")
      el-form-item(:prop="'Subjects.' + index + '.year'", :rules="{required: true, type: 'number', message: 'Задължително'}")
        el-select(v-model="subject.year", placeholder="Година")
          el-option(v-for="y in subjectYears(subject)", :label="y", :value="y", :key="y")
    el-col(:sm="4", v-if="subject.type == 1020")
      el-form-item(:prop="'Subjects.' + index + '.month'", :rules="{required: true, type: 'number', message: 'Задължително'}")
        el-select(v-model="subject.month", placeholder="Месец")
          el-option(v-for="(m, id) in consts.months", :label="m", :value="parseInt(id)", :key="id")
    el-col(:sm="4", v-if="subject.type == 1020")
      el-form-item(:prop="'Subjects.' + index + '.IssueId'", :rules="{required: true, type: 'number', message: 'Задължително'}")
        el-select(v-model="subject.IssueId", placeholder="Издание")
          el-option(v-for="i in issues", :label="i.name", :value="i.id", :key="i.id")
    el-col(:sm="4", v-if="subject.type == 1020")
      el-form-item(:prop="'Subjects.' + index + '.format'", :rules="{required: true, type: 'string', message: 'Задължително'}")
        el-input(v-model="subject.format", placeholder="Формат")
    //- 1030
    el-col(:sm="14", v-if="subject.type == 1030")
      el-form-item(:prop="'Subjects.' + index + '.LiteratureId'", :rules="{required: true, type: 'number', message: 'Задължително'}")
        el-select(v-model="subject.LiteratureId", placeholder="Заглавие/ISBN", :remote-method="literatureAhead", filterable, remote, :loading="literatureLoading", @change="literatureChange")
          el-option(v-for="l in literatureOptions", :label="l.text", :value="l.id", :key="l.id")
    //- 1040
    el-col(:sm="14", v-if="subject.type == 1040")
      el-form-item(:prop="'Subjects.' + index + '.EventId'", :rules="{required: true, type: 'number', message: 'Задължително'}")
        el-select(v-model="subject.EventId", placeholder="Научно събитие/Година", :remote-method="eventAhead", filterable, remote, :loading="eventLoading", @change="eventChange")
          el-option(v-for="e in eventOptions", :label="e.text", :value="e.id", :key="e.id")
    //- IF NOT IN THOSE TYPES
    el-col(:sm="14", v-if="![1010, 1020, 1030, 1040].includes(parseInt(subject.type))")
      el-form-item(:prop="'Subjects.' + index + '.description'", :rules="{required: true, type: 'string', message: 'Задължително'}")
        el-input(v-model="subject.description", placeholder="Основание")


    //- SHARED WITH ALL
    el-col(:sm="2")
      el-form-item(:prop="'Subjects.' + index + '.quantity'", :rules="{required: true, type: 'number', message: 'Задължително'}")
        el-input(v-model.number="subject.quantity", type="number", placeholder="Количество")
    el-col(:sm="3")
      el-form-item(:prop="'Subjects.' + index + '.price'", :rules="{required: true, type: 'number', message: 'Задължително'}")
        el-input.tr(v-model.number="subject.price", placeholder="Цена")
          template(slot="append") лв.
    el-col(:sm="2")
      el-form-item(:prop="'Subjects.' + index + '.discount'", :rules="{required: true, type: 'number', message: 'Задължително'}")
        el-input(v-model.number="subject.discount", type="number" placeholder="Отстъпка")
    el-col(:sm="3")
      el-form-item
        el-input.tr(:value="priceTotal | formatPrice", :disabled="true")
          template(slot="append") лв.

</template>

<script>
export default {
  props: {
    payment: Object,
    subject: Object,
    index: Number,
  },
  data () {
    return {
      literatureOptions: [],
      literatureLoading: false,
      eventOptions: [],
      eventLoading: false
    }
  },
  computed: {
    issues () {
      return this.$auth.check() ? this.$auth.user().tables.issues : []
    },
    priceTotal () {
      return this.subject.quantity * this.subject.price * (1 - this.subject.discount / 100)
    }
  },
  methods: {
    onClose () {
      this.payment.Subjects.splice(this.index, 1)
    },
    subjectYears (subject) {
      const years = []
      const currentYear = new Date().getFullYear()
      const fromYear = 2015//subject.year && subject.year < currentYear ? subject.year : currentYear
      const toYear = currentYear + 1
      for (let i = fromYear; i <= toYear; i++) {
        years.push(i)
      }
      return years
    },
    literatureAhead (term) {
      this.literatureLoading = true
      this.$http.get('/ahead/literature', {params: {term}}).then(response => {
        this.literatureLoading = false
        this.literatureOptions = response.data.results.map(l => {
          l.text = l.title + ' (' + l.isbn + ')'
          return l
        })
      }).catch(error => {
        console.error(error)
        this.$notify.error({title: 'Error', message: 'Error loading literature autocomplete. Check console.'});
      })
    },
    subscriptionTypeChange (id) {
      const type = this.consts.subscriptionType[id]
      console.log(type)
      // this.subject.price = this.consts.subscriptionPrice
      this.subject.discount = type.discount
    },
    subscriptionVariantChange (id) {
      const variant = this.consts.subscriptionVariant[id]
      this.subject.price = variant.price
      this.subject.discount = type.discount
    },
    literatureChange (id) {
      const literature = this.literatureOptions.find(l => l.id === id)
      this.subject.price = literature.price
      this.subject.discount = literature.discount
    },
    eventChange (id) {
      const event = this.eventOptions.find(e => e.id === id)
      this.subject.price = event.price
      this.subject.discount = event.discount
    },
    eventAhead (term) {
      this.literatureLoading = true
      this.$http.get('/ahead/event', {params: {term}}).then(response => {
        this.eventLoading = false
        this.eventOptions = response.data.results.map(e => {
          e.text = e.name + ' (' + e.year + ')'
          return e
        })
      }).catch(error => {
        console.error(error)
        this.$notify.error({title: 'Error', message: 'Error loading event autocomplete. Check console.'});
      })
    }
  },
  watch: {
    subject: {
      handler: function (val, oldVal) {
        this.subject.priceTotal = this.common.subjectPriceTotal(this.subject)
      },
      deep: true
    }
  },
  created () {
    if (this.subject.LiteratureId) {
      const l = this.subject.Literature
      this.literatureOptions = [{...l, text: l.title + ' (' + l.isbn + ')'}]
    }
    if (this.subject.EventId) {
      const e = this.subject.Event
      this.eventOptions = [{...e, text: e.name + ' (' + new Date(e.startsAt).getFullYear() + ')'}]
    }
  }
}
</script>

<style lang="stylus">
.subject-form
  .el-col
    // padding-left 5px
    // padding-right 5px
  .el-form-item
    margin-bottom 10px
</style>
